// utils/db.js
export const DB = {
  get: async (key) => {
    try {
      const result = localStorage.getItem(key);
      return result ? JSON.parse(result) : null;
    } catch (e) {
      console.error(`DB.get error for key "${key}":`, e);
      return null;
    }
  },
  
  set: async (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      console.error(`DB.set error for key "${key}":`, e);
      return false;
    }
  },
  
  del: async (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (e) {
      console.error(`DB.del error for key "${key}":`, e);
      return false;
    }
  }
};
